<!-- display-mobile-05 preview — publisher site, brand row + in-page card -->
<app-mobile-frame>
  <!-- START: Site header -->
  <div class="gs-site-header d-flex flex-row align-items-center justify-content-between" frameTop>
    <i class="bi bi-list"></i>
    <span class="gs-skel gs-skel-brand"></span>
    <i class="bi bi-search"></i>
  </div>
  <!-- END: Site header -->

  <div class="gs-page">
    <span *ngFor="let w of linesAbove" class="gs-skel gs-skel-line" [style.width.%]="w" aria-hidden="true"></span>

    <!-- START: Real ad -->
    <div class="gs-promo">
      <div class="gs-brand-row d-flex flex-row align-items-center">
        <span class="gs-logo"><img src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png" alt="" /></span>
        <div class="gs-brand-info">
          <a class="gs-long-headline" [href]="data.url || null" target="_blank" rel="noopener noreferrer">
            {{ longHeadline }}
          </a>
          <div class="gs-brand-name">Valamar</div>
        </div>
        <i class="bi bi-info-circle gs-info"></i>
      </div>

      <a class="gs-card d-block" [href]="data.url || null" target="_blank" rel="noopener noreferrer">
        <span class="gs-card-image d-flex justify-content-center">
          <img [src]="hotel.image" alt="" />
        </span>
        <span class="gs-card-title">{{ hotel.title }}</span>
        <span class="gs-card-footer d-flex flex-row align-items-center justify-content-between">
          <span class="gs-card-description">{{ hotel.subtitle }}</span>
          <span class="gs-card-cta">{{ ctaText }}</span>
        </span>
      </a>
    </div>
    <!-- END: Real ad -->

    <span *ngFor="let w of linesBelow" class="gs-skel gs-skel-line" [style.width.%]="w" aria-hidden="true"></span>
  </div>
</app-mobile-frame>
